/* eslint-disable */

import axios from "axios";
import { make } from "vuex-pathify";

const url = require("../../client_config/config").url;

const state = {
  dors: [],
  dialog: false,
  loading: false,
  snackbar: { show: false, text: "", color: "green accent-4" },
};

const getters = {
  isLoading: (state) => state.loading,
};

const actions = {
  async getDors({ commit }, id) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/dor/${id}`);
      commit("SET_DOR", response.data.dor);
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async addDOR({ commit }, data) {
    try {
      const response = await axios.post(`${url}/dor/`, data);
      commit("ADD_DOR", response.data.dor);
      commit("SET_SNACKBAR", {
        show: true,
        text: "DOR Successfully Added",
        color: "green accent-4",
      });
      return response.data;
    } catch (error) {
      commit("SET_SNACKBAR", {
        show: true,
        text: error.response.data.message,
        color: "red accent-4",
      });
      return error.response;
    }
  },

  async updateDOR({ commit }, { data, id }) {
    try {
      const response = await axios.put(`${url}/dor/${id}`, data);
      commit("UPDATE_DOR", response.data.dor);
      commit("SET_SNACKBAR", {
        show: true,
        text: "DOR Successfully Updated",
        color: "green accent-4",
      });
      return response.data;
    } catch (error) {
      commit("SET_SNACKBAR", {
        show: true,
        text: error.response.data.message,
        color: "red accent-4",
      });
      return error.response;
    }
  },

  async deleteDOR({ commit }, id) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.delete(`${url}/dor/${id}`);
      commit("DELETE_DOR", id);
      commit("SET_SNACKBAR", {
        show: true,
        text: "DOR Successfully Deleted",
        color: "green accent-4",
      });
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_SNACKBAR", {
        show: true,
        text: error.response.data.message,
        color: "red accent-4",
      });
      return error.response;
    }
  },

  async downloadDOR({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/dor/${data.clientID}/${data.dorID}/download`);
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
};

const mutations = {
  ...make.mutations(state),

  SET_DOR(state, data) {
    state.dors = data;
  },

  ADD_DOR(state, data) {
    state.dors.push(data);
  },

  UPDATE_DOR(state, data) {
    state.dors.splice(
      state.dors.findIndex((item) => item._id === data._id),
      1,
      data
    );
  },

  DELETE_DOR(state, id) {
    state.dors.splice(
      state.dors.findIndex((item) => item._id === id),
      1
    );
  },

  SET_DIALOG(state, data) {
    state.dialog = data;
  },

  SET_LOADING(state, data) {
    state.loading = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
